/** @module Calendar/AddMaterialsToCalendar */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"Calendar"
], function(declare,Controller,Calendar) {

	return declare(Controller, {
		/**
		 * Return true if a calendar is not currently being created for this material
		 * @param {Context} ctx
		 * @param {FormData} fd
		 * @return {boolean}
		 */
		canSelectMaterial: function(ctx, fd) {
			const cache = this.m_cache;
			const calendar = this.getNode();
			const masterCalendar = cache.get(calendar.Master);
			const material = ctx.getNode();

			if (Calendar.calendarGetPendingRequest(masterCalendar, cache, material)) {
				fd.addAggregatedNode(material);
				return false;
			}

			return true;
		},

		/**
		 * @override
		 * Add aggregate test
		 */
		onFormData: function(fd) {
			fd.m_fAggregateTest = (ctx, fd) => this.canSelectMaterial(ctx, fd);
		}
	});
});